import { genComponentEl } from '@/utils/utils';
import Component from './materials-dialog.vue';

/**
 * 显示设备预案
 * @param {Object} data
 */
export function openMaterialsDialog(data) {
  genComponentEl(Component, data);
}
